import { Badge, Button, Col, Descriptions, Divider, Form, Input, Modal, Row, Select, Space, Table, Tag } from "antd"
import { columns, issueData, issue_data } from "./issuedata"
import './issueManagement.less'
import lineIcon from '../../res/line_icon.svg'
import fbMessengerIcon from '../../res/fb_messenger_icon.svg'
import shopeeIcon from '../../res/shopee_icon.svg'
import lazadaIcon from '../../res/lazada_icon.svg'
import tiktokIcon from '../../res/tiktok_icon.svg'
import defaultSourceIcon from '../../res/default_source_icon.svg'
import defaultProfile from '../../res/default_profile.svg'
import React, { useEffect, useLayoutEffect, useRef, useState } from "react"
import dayjs from "dayjs"
import CreateIssue from "../createissue/CreateIssue"
import { useAppDispatch, useAppSelector } from "../../hooks/hooks"
import { editSession, getAllSessionList } from "../../app/services/session"
import { selectManualAdd, selectSessionEditResult, selectSessionList } from "./issueManagementSlice"
import { getBrandList, getSourceList, getCaseStatusList } from "../home/homeActions"
import { selectBrandOptions, selectSourceOptions, selectCaseStatusOptions } from "../home/homeSlice"
import { selectIsMcjeansEmployee } from "../../hooks/auth/authReducer"
import { formatDateTimeIso, formatDatetime, formatDatetimeWithYear, utcToLocalDayjs } from "../../utils/datetime"
import IssueTagging from "../IssueTagging/IssueTagging"
import { create_issue_btn_label, issue_management_menu_label } from "../../wording"
import { manualAddSession } from "../../app/services/session"
import { current } from "@reduxjs/toolkit"
import IssueItem from "../issueItem/IssueItem"
import Item from "antd/lib/list/Item"
import ChatList from "../../components/ChatList/ChatList"
import { selectSession } from "../issueItem/IssueItemSlice"
import html2canvas from "html2canvas"
import SessionForm from "../../components/SessionForm"


const IssueManagement = () => {

    const tagDisplay = JSON.parse(process.env.REACT_APP_TAG_DISPLAY)
    const previewTagRef = useRef(null)
    const dispatch = useAppDispatch();
    const session_list = useAppSelector(selectSessionList)
    const manual_add = useAppSelector(selectManualAdd)
    const session_edit_result = useAppSelector(selectSessionEditResult)
    const brandOptions = useAppSelector(selectBrandOptions)
    const sourceOptions = useAppSelector(selectSourceOptions)
    const caseStatusOptions = useAppSelector(selectCaseStatusOptions)
    const isMcjeansEmployee = useAppSelector(selectIsMcjeansEmployee)
    // const tagging_list =
    const [display_session, setDisplaySession] = useState([])
    const [tagging_list, setTaggingList] = useState([])

    const [tableParams, setTableParams] = useState({
        pagination: {
            sort: 'created_at',
            sort_type: -1,
            current: 1,
            limit: 10
        }
    })

    const [standard_data, setStandardData] = useState({
        user_name: '',
        source: '',
        brand: '',
        chat_started_at_date: null,  // dayjs object for MUI DatePicker
        chat_started_at_time: null,  // dayjs object for MUI TimePicker
        chat_first_response_at_date: null,
        chat_first_response_at_time: null,
        chat_ended_at_date: null,
        chat_ended_at_time: null,
        case_status: 'closed'
    })
    const [standard_data_error, setStandardDataError] = useState({
        visible: false,
        message: ''
    })
    const [datetime_validation_errors, setDatetimeValidationErrors] = useState({
        chat_first_response_at: '',
        chat_ended_at: ''
    })
    const [is_edited_mode, setIsEditedMode] = useState(false)
    const [edit_data, setEditData] = useState({
        user_name: '',
        source: '',
        brand: '',
        session_id: '',
        chat_started_at_date: null,
        chat_started_at_time: null,
        chat_first_response_at_date: null,
        chat_first_response_at_time: null,
        chat_ended_at_date: null,
        chat_ended_at_time: null,
        case_status: 'closed'
    })
    const [edit_datetime_errors, setEditDatetimeErrors] = useState({
        chat_first_response_at: '',
        chat_ended_at: ''
    })
    const [edit_data_error, setEditDataError] = useState({
        visible: false,
        message: ''
    })

    const [search_param, setSearchParam] = useState({
        user_name: '',
        source: '',
        brand: '',
        search: ''
    })
    const [tag_search, setTagSearch] = useState('')
    const session = useAppSelector(selectSession)

    const on_save_event = () => {
        dispatch(getAllSessionList({
            sort: tableParams.pagination.sort,
            sort_type: tableParams.pagination.sort_type,
            limit: tableParams.pagination.limit,
            page: tableParams.pagination.current,
            search: search_param.search,
            user_name: search_param.user_name,
            source: search_param.source,
            brand: search_param.brand
        }))
    }
    const [preview_tag, setPreviewTag] = useState([])

    useEffect(() => {
        switch (session_edit_result.status) {
            case 'fulfilled': {
                dispatch(getAllSessionList({
                    sort: tableParams.pagination.sort,
                    sort_type: tableParams.pagination.sort_type,
                    limit: tableParams.pagination.limit,
                    page: tableParams.pagination.current,
                    search: search_param.search,
                    user_name: search_param.user_name,
                    source: search_param.source,
                    brand: search_param.brand
                }))
                break
            }
        }
    }, [session_edit_result.status])

    useEffect(() => {
        dispatch(getBrandList())
        dispatch(getSourceList())
        dispatch(getCaseStatusList())
        dispatch(getAllSessionList({
            sort: tableParams.pagination.sort,
            sort_type: tableParams.pagination.sort_type,
            limit: tableParams.pagination.limit,
            page: tableParams.pagination.current,
            search: search_param.search,
            user_name: search_param.user_name,
            source: search_param.source,
            brand: search_param.brand
        }))
    }, [])

    useEffect(() => {
        console.log('session_list ', session_list)
    }, [session_list])


    const TABLE_HEADER_HEIGHT = 55

    const [create_action_modal, setCreateActionModal] = useState({
        visible: false
    })
    const [preview_tag_modal, setPreviewTagModal] = useState({
        visible: false
    })
    const [issue_item_modal, setIssueItemModal] = useState({
        visible: false,
        data: {}
    })



    useEffect(() => {
        const data = issue_item_modal.data
        // Parse datetime fields from session data (convert UTC to +7)
        const parseDateTime = (isoString) => {
            const dt = utcToLocalDayjs(isoString)
            return { date: dt, time: dt }
        }

        const chatStarted = parseDateTime(data.chat_started_at)
        const chatFirstResponse = parseDateTime(data.chat_first_response_at)
        const chatEnded = parseDateTime(data.chat_ended_at)

        setEditData({
            user_name: data.user_name || '',
            source: data.source || '',
            brand: data.brand || '',
            session_id: data._id || '',
            chat_started_at_date: chatStarted.date,
            chat_started_at_time: chatStarted.time,
            chat_first_response_at_date: chatFirstResponse.date,
            chat_first_response_at_time: chatFirstResponse.time,
            chat_ended_at_date: chatEnded.date,
            chat_ended_at_time: chatEnded.time,
            case_status: data.case_status
        })
    }, [issue_item_modal.data])

    const handleConfirmIssueItemModal = () => {
        setIssueItemModal({
            ...issue_item_modal,
            visible: false
        })
    }
    const handleCancelIssueItemModal = () => {
        setIssueItemModal({
            ...issue_item_modal,
            visible: false
        })
    }

    const [tableHeight, setTableHeight] = useState(600)
    const tableRef = useRef(null)

    useLayoutEffect(() => {
        const node = tableRef.current
        const { top } = node.getBoundingClientRect()
        const height = window.innerHeight - top - TABLE_HEADER_HEIGHT - 80
        setTableHeight(height)
        console.log(height)
    }, [tableRef])

    const handleConfirmCreateIssue = () => {
        console.log('confirm create issue')

        // Collect all missing fields
        const missingFields = []

        // Basic fields validation
        if (!standard_data.brand) missingFields.push('แบรนด์')
        if (!standard_data.source) missingFields.push('ช่องทางติดต่อ')
        if (!standard_data.user_name) missingFields.push('ชื่อ Social หรือ ชื่อผู้ติดต่อ')

        // Additional validation for non-McJeans employees
        if (!isMcjeansEmployee) {
            if (!standard_data.chat_started_at_date || !standard_data.chat_started_at_time) {
                missingFields.push('เวลาแชทเข้า')
            } else if (!standard_data.chat_started_at_time?.isValid()) {
                missingFields.push('เวลาแชทเข้า (รูปแบบไม่ถูกต้อง)')
            }

            if (!standard_data.chat_first_response_at_date || !standard_data.chat_first_response_at_time) {
                missingFields.push('เวลาตอบแชทครั้งแรก')
            } else if (!standard_data.chat_first_response_at_time?.isValid()) {
                missingFields.push('เวลาตอบแชทครั้งแรก (รูปแบบไม่ถูกต้อง)')
            }

            if (!standard_data.chat_ended_at_date || !standard_data.chat_ended_at_time) {
                missingFields.push('เวลาจบแชท')
            } else if (!standard_data.chat_ended_at_time?.isValid()) {
                missingFields.push('เวลาจบแชท (รูปแบบไม่ถูกต้อง)')
            }

            if (!standard_data.case_status) missingFields.push('สถานะเคส')
        }

        // Show error if any fields are missing
        if (missingFields.length > 0) {
            setStandardDataError({
                visible: true,
                message: `กรุณากรอก: ${missingFields.join(', ')}`
            })
            return
        }

        // Validate datetime sequence (only for non-McJeans employees)
        if (!isMcjeansEmployee && !validateDatetimeSequence()) {
            setStandardDataError({
                visible: true,
                message: 'ลำดับเวลาไม่ถูกต้อง'
            })
            return
        }

        // Save brand and source to localStorage BEFORE resetting
        const preferences = {
            brand: standard_data.brand,
            source: standard_data.source
        }
        localStorage.setItem('create_session_preferences', JSON.stringify(preferences))

        // Prepare payload
        const payload = {
            name: 'default',
            username: standard_data.user_name,
            type: 'manual',
            detail: '',
            tag: tagging_list,
            source: standard_data.source,
            brand: standard_data.brand
        }

        // Add operation metric fields if not McJeans employee
        if (!isMcjeansEmployee) {
            payload.chat_started_at = combineDateAndTime(standard_data.chat_started_at_date, standard_data.chat_started_at_time).toISOString()
            payload.chat_first_response_at = combineDateAndTime(standard_data.chat_first_response_at_date, standard_data.chat_first_response_at_time).toISOString()
            payload.chat_ended_at = combineDateAndTime(standard_data.chat_ended_at_date, standard_data.chat_ended_at_time).toISOString()
            payload.case_status = standard_data.case_status
        }

        dispatch(manualAddSession(payload))

        setCreateActionModal({
            ...create_action_modal,
            visible: false
        })
        setStandardDataError({
            visible: false,
            message: ''
        })
        setDatetimeValidationErrors({
            chat_first_response_at: '',
            chat_ended_at: ''
        })
        setStandardData({
            user_name: '',
            source: '',
            brand: '',
            chat_started_at_date: null,
            chat_started_at_time: null,
            chat_first_response_at_date: null,
            chat_first_response_at_time: null,
            chat_ended_at_date: null,
            chat_ended_at_time: null,
            case_status: 'closed'
        })
        setTaggingList([])
    }

    useEffect(() => {
        switch (manual_add.status) {
            case 'fulfilled': {
                dispatch(getAllSessionList({
                    sort: tableParams.pagination.sort,
                    sort_type: tableParams.pagination.sort_type,
                    limit: tableParams.pagination.limit,
                    page: tableParams.pagination.current,
                    search: search_param.search,
                    user_name: search_param.user_name,
                    source: search_param.source,
                    brand: search_param.brand
                }))
                break
            }
        }
    }, [manual_add.status])

    const handleCancelCreateIssue = () => {
        console.log('cancel create issue')
        setCreateActionModal({
            ...create_action_modal,
            visible: false
        })
        setStandardDataError({
            visible: false,
            message: ''
        })
        setDatetimeValidationErrors({
            chat_first_response_at: '',
            chat_ended_at: ''
        })
        setStandardData({
            user_name: '',
            source: '',
            brand: '',
            chat_started_at_date: null,
            chat_started_at_time: null,
            chat_first_response_at_date: null,
            chat_first_response_at_time: null,
            chat_ended_at_date: null,
            chat_ended_at_time: null,
            case_status: 'closed'
        })
        setTaggingList([])
    }
    const handleClickStartCreateIssue = () => {
        console.log('start create issue modal')

        // Load saved preferences from localStorage when opening modal
        const today = dayjs()
        const savedPreferences = localStorage.getItem('create_session_preferences')
        if (savedPreferences) {
            try {
                const preferences = JSON.parse(savedPreferences)
                setStandardData(prev => ({
                    ...prev,
                    brand: preferences.brand || '',
                    source: preferences.source || '',
                    // Set default date to today for non-McJeans employees
                    chat_started_at_date: !isMcjeansEmployee ? today : null,
                    chat_first_response_at_date: !isMcjeansEmployee ? today : null,
                    chat_ended_at_date: !isMcjeansEmployee ? today : null
                }))
            } catch (error) {
                console.error('Error parsing saved preferences:', error)
            }
        } else {
            // If no saved preferences, still set default date for non-McJeans employees
            if (!isMcjeansEmployee) {
                setStandardData(prev => ({
                    ...prev,
                    chat_started_at_date: today,
                    chat_first_response_at_date: today,
                    chat_ended_at_date: today
                }))
            }
        }

        setCreateActionModal({
            ...create_action_modal,
            visible: true
        })
    }
    const sourceIcon = {
        'line': lineIcon,
        'facebook': fbMessengerIcon,
        'shopee': shopeeIcon,
        'lazada': lazadaIcon,
        'tiktok': tiktokIcon
    }
    const getValueFromTree = (tag_item) => {
        if (tag_item.key) {

        }
        // // check key is sku
        // if (tag_item.key === 'sku'){
        //     return tag_item.value
        // }else{
        //     if(typeof tag_item.value === 'object'){
        //         getValueFromTree(tag_item.value)
        //     }else if(Array.isArray(tag_item.value){
        //         getValueFromTree()
        //     })
        // }
        // // if sku return 
        // // else 
        // // if object
        // // if array
    }

    const searchTagByKey = (tag, description) => {
        if (tag) {
            if (typeof (tag) === 'object' && !Array.isArray(tag)) {
                if (tag?.description === description) {
                    return tag
                } else {
                    return searchTagByKey(tag.value, description)
                }
            } else if ((Array.isArray(tag))) {
                let obj = tag.find(e => e.key === description)
                if (obj) {
                    return obj
                } else {
                    return searchTagByKey(tag.value, description)
                }
            }
        } else {
            return null
        }
    }
    const showTagDescriptionByDeepLevel = (tag, level) => {
        let output = tag
        for (let i = 0; i < level; i++) {
            output = output?.value
        }
        return output?.description
    }

    const transformToDisplaySession = (session_list_data) => {
        let output = []
        session_list_data.map((session_item_data, index) => {
            const tags = []
            if (session_item_data.tag) {
                session_item_data.tag?.map(tag_item => {
                    let found = searchTagByKey(tag_item, tagDisplay.tag)
                    if (found) {
                        tags.push(showTagDescriptionByDeepLevel(found, tagDisplay.level))
                    }
                })
            }
            output.push({
                key: session_item_data._id,
                source: session_item_data.source,
                user_name: session_item_data.user_name,
                agent_email: session_item_data.agent_email,
                created_at: session_item_data.created_at,
                raw_data: session_item_data,
                conversations: session_item_data.conversations,
                tags: tags
            })
        })
        return output
    }
    useEffect(() => {
        switch (session_list.status) {
            case 'fulfilled': {
                console.log('session_list_data', session_list.data.session)
                setDisplaySession(transformToDisplaySession(session_list.data?.session))
                break
            }
        }
    }, [session_list.status])
    const handleClickUser = (user) => {
        console.log(user)
        setSearchParam({
            ...search_param,
            user_name: user
        })
    }
    const columns = [
        {
            title: '',
            dataIndex: 'source',
            key: 'source',
            render: (text) => <img
                style={{ width: '40px', height: '40px', borderRadius: '50%' }}
                src={sourceIcon[text?.toLowerCase()] ? sourceIcon[text?.toLowerCase()] : defaultSourceIcon}
                alt="Avatar" />
        },
        {
            title: 'ชื่อ Social หรือ ชื่อผู้ติดต่อ',
            dataIndex: 'user_name',
            key: 'user_name',
            render: (text) => <a onClick={(e) => {
                e.stopPropagation()
                handleClickUser(text)
            }}>{text}</a>,
        },
        {
            title: 'พนักงานรับเรื่อง',
            dataIndex: 'agent_email',
            key: 'agent_email',
            render: (text) => <span>{text}</span>
        },
        // {
        //     title: 'Status',
        //     dataIndex: 'status',
        //     key: 'status',
        //     render: () => <Badge status="success" text="Finished" />,
        // },
        {
            title: 'เวลา',
            dataIndex: 'created_at',
            key: 'created_at',
            sorter: true,
            render: (timestring) => <span>{formatDatetimeWithYear(timestring)}</span>
        },
        {
            title: 'tags',
            dataIndex: 'tags',
            render: (tags) => (
                <>
                    {tags.map((tag, index) => (
                        <Tag color="blue" key={`${tag}_${index}`}>
                            {tag}
                        </Tag>
                    ))}
                </>
            )
        }
        // {
        //     title: 'Action',
        //     key: 'action',
        //     render: (_, record) => (
        //         <Space size="middle">
        //             <a>Edit</a>
        //             {/* <a>Edit {record.username}</a> */}
        //             <a>Delete</a>
        //         </Space>
        //     ),
        // },
    ];
    const handleChangeTable = (pagination, filters, sorter) => {
        console.log('handle change', sorter)
        let sort_type
        let sort_field
        if (sorter.hasOwnProperty("column")) {
            sort_field = sorter.field
            switch (sorter.order) {
                case 'ascend': {
                    sort_type = 1
                    break
                }
                case 'descend': {
                    sort_type = -1
                    break
                }
                default: {
                    sort_type = 0
                    break
                }
            }
            // params.order = { field: sorter.field, dir: sorter.order };
        } else {
            sort_field = 'created_at'
            sort_type = -1
        }
        // const offset = pagination.current * pagination.pageSize - pagination.pageSize
        const current = pagination.current
        const limit = pagination.pageSize

        console.log('current', current)

        setTableParams({
            pagination: {
                sort: sort_field,
                sort_type: sort_type,
                limit: limit,
                current: current
            }
        })

    }


    useEffect(() => {
        dispatch(getAllSessionList({
            sort: tableParams.pagination.sort,
            sort_type: tableParams.pagination.sort_type,
            limit: tableParams.pagination.limit,
            page: tableParams.pagination.current,
            search: search_param.search,
            user_name: search_param.user_name,
            source: search_param.source,
            brand: search_param.brand
        }))
    }, [tableParams, search_param.user_name, search_param.source, search_param.brand, search_param.search])

    const handleClickRow = (record) => {

        setIssueItemModal({
            ...issue_item_modal,
            visible: true,
            data: record.raw_data
        })
    }
    // Unified handler for standard_data (create modal)
    const handleStandardDataChange = (field, value) => {
        setStandardData(prev => ({
            ...prev,
            [field]: value
        }))
    }

    // Transform API response arrays to {value, label} format
    const source_options = sourceOptions ? sourceOptions.map(source => ({
        value: source,
        label: source
    })) : []

    const brand_options = brandOptions ? brandOptions.map(brand => ({
        value: brand,
        label: brand
    })) : []

    const case_status_options = caseStatusOptions ? caseStatusOptions.map(status => ({
        value: status,
        label: status
    })) : []

    const handleClickEditMode = () => {
        setIsEditedMode(true)
    }
    const handleCancelEditStandardData = () => {
        setIsEditedMode(false)
    }
    const handleSubmitEditStandardData = () => {
        // Basic validation
        if (!edit_data.user_name || !edit_data.source || !edit_data.brand) {
            setEditDataError({
                visible: true,
                message: 'ข้อมูลพื้นฐานไม่ครบ'
            })
            return
        }

        // Additional validation for non-McJeans employees
        if (!isMcjeansEmployee) {
            // Check if all operation metric fields are filled
            if (!edit_data.chat_started_at_date || !edit_data.chat_started_at_time ||
                !edit_data.chat_first_response_at_date || !edit_data.chat_first_response_at_time ||
                !edit_data.chat_ended_at_date || !edit_data.chat_ended_at_time ||
                !edit_data.case_status) {
                setEditDataError({
                    visible: true,
                    message: 'กรุณากรอกข้อมูลเมตริกให้ครบถ้วน'
                })
                return
            }

            // Validate time values (check if dayjs objects are valid)
            if (!edit_data.chat_started_at_time?.isValid() ||
                !edit_data.chat_first_response_at_time?.isValid() ||
                !edit_data.chat_ended_at_time?.isValid()) {
                setEditDataError({
                    visible: true,
                    message: 'กรุณาเลือกเวลาให้ถูกต้อง'
                })
                return
            }

            // Validate datetime sequence
            if (!validateEditDatetimeSequence()) {
                setEditDataError({
                    visible: true,
                    message: 'ลำดับเวลาไม่ถูกต้อง'
                })
                return
            }
        }

        // Prepare payload
        const payload = {
            session_id: edit_data.session_id,
            user_name: edit_data.user_name,
            source: edit_data.source,
            brand: edit_data.brand
        }

        // Add operation metric fields if not McJeans employee
        if (!isMcjeansEmployee) {
            const chatStarted = combineDateAndTime(edit_data.chat_started_at_date, edit_data.chat_started_at_time)
            const chatFirstResponse = combineDateAndTime(edit_data.chat_first_response_at_date, edit_data.chat_first_response_at_time)
            const chatEnded = combineDateAndTime(edit_data.chat_ended_at_date, edit_data.chat_ended_at_time)

            if (chatStarted) payload.chat_started_at = chatStarted.toISOString()
            if (chatFirstResponse) payload.chat_first_response_at = chatFirstResponse.toISOString()
            if (chatEnded) payload.chat_ended_at = chatEnded.toISOString()
            if (edit_data.case_status) payload.case_status = edit_data.case_status
        }

        // Clear error on successful validation
        setEditDataError({
            visible: false,
            message: ''
        })

        dispatch(editSession(payload))

        setIsEditedMode(false)

        on_save_event()
    }

    // Unified handler for edit_data (edit modal)
    const handleEditDataChange = (field, value) => {
        setEditData(prev => ({
            ...prev,
            [field]: value
        }))
    }

    const handleClearSearchParam = () => {
        setSearchParam({
            search: '',
            user_name: '',
            source: '',
            brand: ''
        })
        setTagSearch('')
    }

    const handleChangeUsernameFilter = (event) => {
        setSearchParam({
            ...search_param,
            user_name: event.target.value
        })
        // console.log(event.target.value)
        // dispatch(getAllSessionList({
        //     sort: 'created_at',
        //     sort_type: -1,
        //     limit: tableParams.pagination.limit,
        //     page: tableParams.pagination.current,
        //     user_name: event.target.value,
        //     search: ''
        // }))
    }
    const handleChangeSourceFilter = (value) => {
        setSearchParam({
            ...search_param,
            source: value
        })
    }
    const handleChangeBrandFilter = (value) => {
        setSearchParam({
            ...search_param,
            brand: value
        })
    }
    // Combine date and time dayjs objects into a single datetime
    const combineDateAndTime = (dateObj, timeObj) => {
        // Both are dayjs objects from MUI pickers
        if (!dateObj || !timeObj) return null
        if (!dateObj.isValid() || !timeObj.isValid()) return null

        const combined = dateObj
            .hour(timeObj.hour())
            .minute(timeObj.minute())
            .second(0)
        return combined.isValid() ? combined : null
    }

    const validateDatetimeSequence = () => {
        const errors = {
            chat_first_response_at: '',
            chat_ended_at: ''
        }

        const chatStarted = combineDateAndTime(standard_data.chat_started_at_date, standard_data.chat_started_at_time)
        const chatFirstResponse = combineDateAndTime(standard_data.chat_first_response_at_date, standard_data.chat_first_response_at_time)
        const chatEnded = combineDateAndTime(standard_data.chat_ended_at_date, standard_data.chat_ended_at_time)

        // Validate chat_first_response_at is after chat_started_at
        if (chatStarted && chatFirstResponse && chatFirstResponse.isBefore(chatStarted)) {
            errors.chat_first_response_at = '⚠️ เวลาตอบแชทครั้งแรกต้องมาหลังเวลาแชทเข้า'
        }

        // Validate chat_ended_at is after chat_first_response_at
        if (chatFirstResponse && chatEnded && chatEnded.isBefore(chatFirstResponse)) {
            errors.chat_ended_at = '⚠️ เวลาจบแชทต้องมาหลังเวลาตอบแชทครั้งแรก'
        }

        setDatetimeValidationErrors(errors)
        return !errors.chat_first_response_at && !errors.chat_ended_at
    }

    // Validate datetime sequence whenever any datetime field changes (create modal)
    useEffect(() => {
        if (!isMcjeansEmployee) {
            validateDatetimeSequence()
        }
    }, [
        standard_data.chat_started_at_date,
        standard_data.chat_started_at_time,
        standard_data.chat_first_response_at_date,
        standard_data.chat_first_response_at_time,
        standard_data.chat_ended_at_date,
        standard_data.chat_ended_at_time
    ])

    // Validation for edit modal datetime sequence
    const validateEditDatetimeSequence = () => {
        const errors = {
            chat_first_response_at: '',
            chat_ended_at: ''
        }

        const chatStarted = combineDateAndTime(edit_data.chat_started_at_date, edit_data.chat_started_at_time)
        const chatFirstResponse = combineDateAndTime(edit_data.chat_first_response_at_date, edit_data.chat_first_response_at_time)
        const chatEnded = combineDateAndTime(edit_data.chat_ended_at_date, edit_data.chat_ended_at_time)

        if (chatStarted && chatFirstResponse && chatFirstResponse.isBefore(chatStarted)) {
            errors.chat_first_response_at = '⚠️ เวลาตอบแชทครั้งแรกต้องมาหลังเวลาแชทเข้า'
        }

        if (chatFirstResponse && chatEnded && chatEnded.isBefore(chatFirstResponse)) {
            errors.chat_ended_at = '⚠️ เวลาจบแชทต้องมาหลังเวลาตอบแชทครั้งแรก'
        }

        setEditDatetimeErrors(errors)
        return !errors.chat_first_response_at && !errors.chat_ended_at
    }

    // Validate datetime sequence whenever any datetime field changes (edit modal)
    useEffect(() => {
        if (!isMcjeansEmployee && issue_item_modal.visible) {
            validateEditDatetimeSequence()
        }
    }, [
        edit_data.chat_started_at_date,
        edit_data.chat_started_at_time,
        edit_data.chat_first_response_at_date,
        edit_data.chat_first_response_at_time,
        edit_data.chat_ended_at_date,
        edit_data.chat_ended_at_time
    ])

    const handleChangeTaggingSearch = (event) => {
        setTagSearch(event.target.value)
    }
    const handleSubmitSearch = () => {
        console.log('tag', tag_search)
        setSearchParam({
            ...search_param,
            search: tag_search
        })
    }
    const handlePreviewSessionTag = () => {
        setPreviewTagModal({
            visible: true
        })
        console.log(issue_item_modal.data)
        setPreviewTag(unfoldTaggings(issue_item_modal.data.tag))

    }
    const handleClosePreviewTag = () => {
        setPreviewTagModal({
            visible: false
        })
    }
    const unfoldTaggings = (tags) => {
        let outputTags = []
        console.log(tags)
        console.log('1')
        tags?.map(tag_item => {
            console.log(tag_item)
            let unfolded = unfoldTagging(tag_item)
            outputTags.push(unfolded)
        })
        console.log(outputTags)
        return outputTags
        // return outputTag
    }

    const unfoldTagging = (tag, parent, hist = []) => {
        if (tag.value) {
            if (typeof tag.value === 'object' && !Array.isArray(tag.value)) {
                unfoldTagging(tag.value, tag.description, hist)
            } else if (Array.isArray(tag.value)) {
                for (let i = 0; i < tag.value.length; i++) {
                    unfoldTagging(tag.value[i], tag.description, hist)
                }
            } else {
                hist.push({ key: tag.description, value: tag.value })
            }
        } else {
            hist.push({ key: parent, value: tag.description })
        }
        return hist
    }
    // const previewTag = document.getElementById('preview_tag')

    const handleDownloadPreview = async () => {
        console.log(previewTagRef.current.value)
        html2canvas(previewTagRef.current).then(function (canvas) {
            let data = canvas.toDataURL('image/jpg'),
                link = document.createElement('a');

            link.href = data;
            let link_url = issue_item_modal.data.user_name + '-' + formatDateTimeIso(Date.now()) + '.jpg'
            link.download = link_url;

            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
        })
        // const element = document.getElementById("preview_tag")
        // let canvas =   html2canvas(element)
        // let data = canvas.toDataURL('image/jpg')
        // let link = document.createElement('a')

        // link.href = data;
        // link.download = 'downloaded-image.jpg'

        // document.body.appendChild(link)
        // link.click()
        // document.body.removeChild(link)
        // html2canvas(document.getElementById('slip-content-container')).then(function(canvas) {
        //     setProgress(40)
        //     const context = canvas.getContext('2d')
        //     const width = canvas.width
        //     const height = canvas.height
        //     setProgress(50)
        // try {
        //   setProgress(75)
        //   app.deviceObj.brightness = 0.5
        //   app.deviceObj.halftone = app.deviceObj.HALFTONE_THRESHOLD
        //   app.deviceObj.addImage(context, 0, 0, width, height, app.deviceObj.COLOR_1, app.deviceObj.MODE_MONO)
        //   app.deviceObj.addCut(app.deviceObj.CUT_FEED)
        //   app.deviceObj.send()
        //   setProgress(100)
        // } catch (e) {
        //   setPrintStatus(false)
        //   connect()
        // }
        // setTimeout(() => {
        //   setProgress(0)
        // }, 2000)


    }


    return (
        <div style={{ height: '100vh', width: '100%', paddingTop: '31px', paddingLeft: '74px', paddingRight: '74px', paddingBottom: '31px', overflow: 'auto', display: 'flex', flexDirection: 'column' }}>
            {/* สร้างรายการใหม่ */}
            <Modal
                title="Preview"
                footer={false}
                visible={preview_tag_modal.visible}
                onCancel={handleClosePreviewTag}
                cancelText="ปิด"
                width="90%">
                <div ref={previewTagRef}>
                    <Descriptions
                        labelStyle={{ width: '250px' }}
                        bordered>
                        <Descriptions.Item span={3} label="แบรนด์">{issue_item_modal.data.brand}</Descriptions.Item>
                        <Descriptions.Item span={3} label="ช่องทาง">{issue_item_modal.data.source}</Descriptions.Item>
                        <Descriptions.Item span={3} label="ชื่อลูกค้า">{issue_item_modal.data.user_name}</Descriptions.Item>
                        <Descriptions.Item span={3} label="ผู้รับเรื่อง">{issue_item_modal.data.agent_email}</Descriptions.Item>
                        {
                            preview_tag.map((preview_tag_item, i) => {
                                return <>
                                    {
                                        preview_tag_item.map(item => {
                                            return (
                                                <Descriptions.Item span={3} label={item.key}>{item.value}</Descriptions.Item>
                                            )
                                        })
                                    }
                                </>
                            })
                        }
                    </Descriptions>
                </div>
                <Button onClick={handleDownloadPreview}>Download</Button>
            </Modal>
            <Modal
                title={create_issue_btn_label}
                visible={create_action_modal.visible}
                onOk={handleConfirmCreateIssue}
                okText="ยืนยันสร้างรายการใหม่"
                onCancel={handleCancelCreateIssue}
                cancelText="ยกเลิก"
                width={1000}>
                <div>
                    <Divider><h2>ข้อมูลพื้นฐาน</h2></Divider>
                    <SessionForm
                        mode="create"
                        data={standard_data}
                        onChange={handleStandardDataChange}
                        showOperationMetrics={!isMcjeansEmployee}
                        brandOptions={brand_options}
                        sourceOptions={source_options}
                        caseStatusOptions={case_status_options}
                        datetimeErrors={datetime_validation_errors}
                    />

                    {standard_data_error.visible ?
                        <div style={{ width: '100%', height: '10%', textAlign: 'right', color: 'red' }}>{standard_data_error.message}</div>
                        : <></>}


                    <Divider><h2>ข้อมูลเพิ่มเติม</h2></Divider>
                    <IssueTagging
                        parent_type='manual'
                        tagging_list={tagging_list}
                        setTaggingList={setTaggingList}
                        on_save={() => {}} />
                </div>
                {/* <CreateIssue /> */}
            </Modal>
            <Modal
                width={1000}
                bodyStyle={{ height: '600px' }}
                footer={null}
                visible={issue_item_modal.visible}
                onOk={handleConfirmIssueItemModal}
                onCancel={handleCancelIssueItemModal}

            >
                <Row style={{ height: '100%', width: '100%' }}>
                    <Col style={{ height: '100%', borderStyle: 'solid' }} className="chat-preview-container" span={12}>

                        <ChatList
                            container_id='issue_management_chatlist'
                            className='chatlist'
                            // history={props.history}
                            chats={session?.data?.conversations}
                        // next={props.next}
                        // has_more={props.has_more}
                        />
                    </Col>
                    <Col style={{ height: '100%', overflow: 'auto', padding: '15px' }} span={12}>

                        <Button style={{ float: 'right' }} onClick={handlePreviewSessionTag}>Preview</Button>
                        <Divider><h2>ข้อมูลพื้นฐาน</h2></Divider>
                        <div style={{ textAlign: 'right' }}>
                            <Button type="primary" onClick={handleClickEditMode}>แก้ไขข้อมูลพื้นฐาน</Button>
                        </div>

                        <SessionForm
                            mode="edit"
                            data={edit_data}
                            onChange={handleEditDataChange}
                            showOperationMetrics={!isMcjeansEmployee}
                            brandOptions={brand_options}
                            sourceOptions={source_options}
                            caseStatusOptions={case_status_options}
                            disabled={!is_edited_mode}
                            datetimeErrors={edit_datetime_errors}
                        />

                        {edit_data_error.visible && (
                            <div style={{ width: '100%', textAlign: 'right', color: 'red', marginTop: '10px' }}>
                                {edit_data_error.message}
                            </div>
                        )}

                        {
                            is_edited_mode ? <div style={{ textAlign: 'right', marginTop: '15px' }}>
                                <Button type="primary" danger onClick={handleCancelEditStandardData}>ยกเลิกบันทึกข้อมูลพื้นฐาน</Button>
                                <Button type="primary" onClick={handleSubmitEditStandardData}>บันทึกข้อมูลพื้นฐาน</Button>
                            </div> : <></>
                        }

                        <Divider><h2>ข้อมูลเพิ่มเติม</h2></Divider>
                        <IssueItem
                            on_save_event={on_save_event}
                            data={issue_item_modal.data}
                        />
                    </Col>
                </Row>


            </Modal>
            <Row style={{ width: '100%', height: '10%' }}>
                <Col className="page-header">{issue_management_menu_label}</Col>
                <Col style={{ marginLeft: 'auto' }}><Button onClick={handleClickStartCreateIssue} className="btn-create-issue" >{create_issue_btn_label}</Button></Col>
            </Row>
            <Row style={{ width: '100%', minHeight: '10%', display: 'flex', alignItems: 'center', flexWrap: 'wrap', marginBottom: '10px' }}>
            <Col style={{ padding: '10px' }}>
                    แบรนด์:
                    <Select
                        value={search_param.brand}
                        allowClear
                        style={{ width: '120px' }}
                        options={brand_options}
                        onChange={handleChangeBrandFilter}
                    />
                </Col>
                <Col style={{ padding: '10px' }}>
                    ช่องทางติดต่อ:
                    <Select
                        value={search_param.source}
                        allowClear
                        // disabled={!is_edited_mode}
                        style={{ width: '120px' }}
                        options={source_options}
                        // value={}
                        onChange={handleChangeSourceFilter}
                    />
                    {/* <Input style={{ borderRadius: '60px', height: '44px', paddingLeft: '30px' }} placeholder='ค้นหาชื่อ Social หรือ ชื่อผู้ติดต่อ' /> */}
                </Col>
                <Col style={{ padding: '10px' }}>
                    <Input
                        placeholder="ค้นหาข้อมูล tag"
                        value={tag_search}
                        onChange={handleChangeTaggingSearch}
                    />
                    {/* <Input style={{ borderRadius: '60px', height: '44px', paddingLeft: '30px' }} placeholder='ค้นหาชื่อ พนักงาน' /> */}
                </Col>
                <Col>
                    <Button onClick={handleSubmitSearch}>ค้นหา</Button>

                </Col>
                <Col style={{ padding: '10px' }}>
                    <Input
                        value={search_param.user_name}
                        onChange={handleChangeUsernameFilter}
                        style={{ borderRadius: '60px', height: '44px', paddingLeft: '30px' }}
                        placeholder='ค้นหาชื่อ Social หรือ ชื่อผู้ติดต่อ' />
                </Col>
                <Col>
                    <Button onClick={handleClearSearchParam}>ล้างการค้นหาทั้งหมด</Button>
                </Col>
            </Row>
            <div
                ref={tableRef}
                style={{ flex: 1, overflow: 'hidden' }}>
                <Table
                    onChange={handleChangeTable}
                    pagination={{
                        // pageSize: 50,
                        total: session_list?.data?.sessions_count
                    }}
                    columns={columns}
                    dataSource={display_session}
                    rowClassName='table-row'
                    onRow={(record, rowIndex) => {
                        return {
                            onClick: (event) => {
                                handleClickRow(record)
                                // console.log(record)
                                // console.log(event.target)
                            }
                        }
                    }}
                    onClick={(event) => {
                        console.log(event)
                    }}
                    scroll={{
                        x: 1500,
                        y: tableHeight
                    }} />
            </div>
        </div>
    )
}
export default IssueManagement